function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDensityDefaulti = function SvgDensityDefaulti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M22.205 14.5a1.7 1.7 0 0 0-1.7-1.7h-17a1.7 1.7 0 0 0-1.7 1.7v6a1.7 1.7 0 0 0 1.7 1.7h17a1.7 1.7 0 0 0 1.7-1.7zm-1.4 0v6c0 .166-.13.3-.3.3h-17c-.17 0-.3-.134-.3-.3v-6c0-.166.13-.3.3-.3h17c.17 0 .3.134.3.3m-11.53 3c0-1.214-.99-2.2-2.2-2.2a2.2 2.2 0 1 0 0 4.4c1.21 0 2.2-.986 2.2-2.2m-1.4 0a.8.8 0 1 1-1.6 0 .8.8 0 1 1 1.6 0m3.73.7h3.71c.38 0 .7-.314.7-.7s-.32-.7-.7-.7h-3.71c-.39 0-.71.314-.71.7s.32.7.71.7m10.6-14.7a1.7 1.7 0 0 0-1.7-1.7h-17a1.7 1.7 0 0 0-1.7 1.7v6a1.7 1.7 0 0 0 1.7 1.7h17a1.7 1.7 0 0 0 1.7-1.7zm-1.4 0v6c0 .166-.13.3-.3.3h-17c-.17 0-.3-.134-.3-.3v-6c0-.166.13-.3.3-.3h17c.17 0 .3.134.3.3m-11.53 3c0-1.214-.99-2.2-2.2-2.2a2.2 2.2 0 1 0 0 4.4c1.21 0 2.2-.986 2.2-2.2m-1.4 0a.8.8 0 1 1-1.6 0 .8.8 0 1 1 1.6 0m3.73.7h5.79c.38 0 .7-.314.7-.7s-.32-.7-.7-.7h-5.79c-.39 0-.71.314-.71.7s.32.7.71.7"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDensityDefaulti);
export default ForwardRef;